import { TFunction } from "i18next";
import { PieChartItem } from "../../../../../../components/charts/graph/SimplePieChart";
import { WaterfallKey } from "../../../../../../components/charts/graph/WaterfallChart/data";
import { RootCauseWidgetWaterfallDTO } from "../../../../../../datasources/api-client/data-contracts";

const pieChartConfig = {
	reportingScope: {
		color: "#3b82f6",
	},
	weightScope: {
		color: "#22c55e",
	},
	distanceScope: {
		color: "#f59e0b",
	},
	modalScope: {
		color: "#a855f7",
	},
	fuelQty: {
		color: "#ef4444",
	},
	fuelMix: {
		color: "#14b8a6",
	},
} as const;

type ScopeKey = keyof typeof pieChartConfig;

export const getRootCauseWaterfallLabels = (
	t: TFunction<"whatif.rootcause">
): Record<WaterfallKey, string> => ({
	baseline: t("root cause results/waterfall elements/baseline"),
	reportingScope: t("root cause results/waterfall elements/reporting scope"),
	weightScope: t("root cause results/waterfall elements/weight scope"),
	distanceScope: t("root cause results/waterfall elements/mileage"),
	modalScope: t("root cause results/waterfall elements/modal scope"),
	fuelQty: t("root cause results/waterfall elements/fuel quantity"),
	fuelMix: t("root cause results/waterfall elements/fuel mix"),
	comparison: t("root cause results/waterfall elements/comparison"),
});

export const mapRootCauseWaterfallToPieChart = (
	data: RootCauseWidgetWaterfallDTO | undefined,
	labels: Record<WaterfallKey, string>
): PieChartItem[] =>
	(Object.keys(pieChartConfig) as ScopeKey[]).map((key) => ({
		id: key,
		label: labels[key],
		color: pieChartConfig[key].color,
		value: data?.[key]?.value ?? 0,
		measure: data?.[key]?.measure ?? "",
		percentage: data?.[key]?.percentage ?? 0,
	}));
